import React,{useState,useEffect} from "react";
import { useSearchParams } from "react-router-dom";
import CryptoJS from "crypto-js";

const LinkedInSignUp=()=>{
    const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_LINKEDIN_REDIRECT_URI;
  const serverURL = process.env.REACT_APP_SERVER_URL;

  const handleSignUp = () => {
    const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&state=SIGNUP_STATE_123&scope=openid%20profile%20email&redirect_uri=${redirectUri}`;

    console.log(authUrl, "Signup URL");
    window.location.href = authUrl;
  };

  const queryParams = new URLSearchParams(window.location.search);
  const code = queryParams.get("code");

  useEffect(() => {
    if (code) {
      exchangeCodeForToken(code);
    }
  }, [code]);

  const exchangeCodeForToken = async (authCode) => {
    const encryptedData = CryptoJS.AES.encrypt(
              JSON.stringify(authCode),
              process.env.REACT_APP_SECRETKEY
            ).toString();
    
            const encryptjson = { data: encryptedData };
    try {
      const response = await fetch(`${serverURL}/getTokenValue`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(encryptjson),
      });

      const result = await response.json();
      console.log("LinkedIn Login Result:", result);
      
      if (result.error) throw new Error(result.error);
    } catch (error) {
      console.error("LinkedIn authentication failed", error);
    }
  };




  return (
    <div className="flex justify-center">
    <div>
      <h2>Sign up with LinkedIn</h2>
      <button className="text-blue-600 underline" onClick={handleSignUp}>Sign Up with LinkedIn</button>
      </div>
    </div>
  );
}
export default LinkedInSignUp;